<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'contracts',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/contracts/index', label: 'Contracts' }
      ]
    })
  }
</script>

<style scoped>
  .contracts {
    z-index: 1;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/Contracts.Entry.vue